import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyImport, LazyModule } from "owa-bundling";
import { getStore } from "./store/store";

// Create lazily loadable FolderPermissions chunk.
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "FolderPermissions" */ "./lazyIndex"), { name: "FolderPermissions" });

/**
 * Action which others can use to open folder permissions dialog.
 * It gets lazily loaded with the 'FolderPermissions' chunk.
 */
export const lazyOpenFolderPermissions: LazyImport<typeof lazyIndex.openFolderPermissionsDialog, typeof lazyModule> = new LazyImport(lazyModule, m => m.openFolderPermissionsDialog);

/**
 * This component show Folder Permissions Dialog in UI.
 * It gets lazily loaded with the 'FolderPermissions' chunk.
 */
export const LazyFolderPermissionsDialog: typeof lazyIndex.FolderPermissionsDialog = createLazyComponent(lazyModule, m => m.FolderPermissionsDialog, undefined, undefined, {
    onlyImportIf: () => getStore().showFolderPermissionsDialog,
});

/**
 * This component shows Allow Parent Access Dialog in UI.
 * It gets lazily loaded with the 'FolderPermissions' chunk.
 */
export const LazyAllowParentAccessDialog: typeof lazyIndex.AllowParentAccessDialog = createLazyComponent(lazyModule, m => m.AllowParentAccessDialog, undefined, undefined, {
    onlyImportIf: () => getStore().showAllowParentAccessDialog,
});
